let employeeStatus = {
  "candidate": "Neue Bewerbung",
  "interviewee": "Telefontermin versendet",
  "telephone-interview": "Telefontermin",
  "data-requested": "Stammdaten angefordert",
  "data-provided": "Stammdaten vom Bewerber bearbeitet",
  "data-verified": "Stammdaten komplett",
  "training-session": "Schulungstermin",
  "training-verified": "Schulung abgeschlossen",
  "offered": "Vertragsangebot",
  "onboarding": "onboarding",
  "rebuddy": "Rebuddy",
  "data-re-requested": "Stammdatencheck angefordert",
  "data-re-provided": "Stammdaten bestätigt",
  "re-offered": "Vertragsangebot",
  "active": "Aktiver Mitarbeiter",
  // 'sabbatical': 'Freigestellt',
  "inactive": "Inaktiv",
  "pool": "Pool"
};
let maritalStatus = {
  "single": "Ledig",
  "divorced": "Geschieden",
  "married": "Verheiratet",
  "widowed": "Verwitwet",
  "other": "Sonstiger Status"
};
const genderOptions = {
  "male": "Männlich",
  "female": "Weiblich",
  "other": "Divers"
};
const asSelectItems = (obj) => Object.entries(obj).map(([key, value]) => ({ value: key, name: value }));
export {
  asSelectItems as a,
  employeeStatus as e,
  genderOptions as g,
  maritalStatus as m
};
//# sourceMappingURL=options.js.map
